<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div style="border: 1px solid #ccc; border-radius: 5px">
            <video
              v-if="item01.type == 2"
              id="videoId"
              width="364px"
              height="300"
              :src="item01.videoUrl"
              autoplay
              muted
            ></video>
            <img
              v-else-if="item01.type == 1"
              :src="item01.photoUrl"
              alt="暂无图片"
            />
          </div>
          <div class="Introduction">
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_AR.jpg",
          p: "本软件对质量样板相关构件进行了全真模拟，涵盖建筑、结构、机电管道安装等几大块质量样板区域，工程质量样板虚拟体验软件以标准化模式开发研制，在工程项目中可普遍推广",
          ref: "AR质量样板应用体验APP",
          type: 1,
        },
        {
          photoUrl: "../../../static/img/photo/photo_yb.png",
          videoUrl: "../../../static/video/ar.mp4",
          p: "AR质量样板是一种基于增强现实技术的质量检测工具。它可以通过将虚拟模型与实际建筑物结合起来，帮助工人和监理人员更加直观地了解建筑物的设计图纸，并辅助进行施工过程中的质量检查和问题解决。 建设工程质量关系到群众的切实利益与施工企业的生命。要保证工程施工质量，增强质量责任意识，要从施工过程的各个环节方面落实责任，全面推行质量保证体系。",
          ref: "AR工法质量样板",
          type: 2,
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 330px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: 15px;
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/AR.vue